import Backbone from 'backbone';

export default Backbone.View.extend({
  initialize(o) {
    this.em = o.em;
    this.model = o.model;
    this.parent = o.parent;
  },

  events: {
    'click .item': 'itemClicked',
    'click i': 'deleteState'
  },

  template(name) {
    return `<div class="item">${name}</div>`;
  },

  deleteState(e) {
    if (!this.model.get('isActive')) {
      this.parent.trigger('stateDeleted', this.model);
      this.$el.remove();
    }
  },

  itemClicked(e) {
    this.model.collection.resetToDefault();
    this.model.set('isActive', true);
    this.parent.trigger('stateSelected', this.model);
    this.model.startRecordingState();
  },

  render() {
    this.$el.addClass('item-wrapper');
    this.$el.append(this.template(this.model.get('name')));
    this.$el.append(`<i class="fa fa-trash ${this.model.get('icon')}">`);
    return this;
  }
});
